import styled from 'styled-components';
import { Form } from 'antd';
export const StyledMobileFilterForm = styled(Form)`
  width: 100%;
  font-family: ${(props) => props.theme.fontText};

  .category-sel-wrap {
    display: flex;
    flex-direction: column;

    .form-title {
      display: none;
    }

    .ant-form-item {
      width: 100%;
      margin-bottom: 0;
    }

    .ant-select-selector {
      background-color: ${(props) => props.theme.softShadowGray};
      border: 1px solid ${(props) => props.theme.softSlateBlue};
      min-width: 245px;
      min-height: 45px;
      border-radius: 5px;
    }

    .ant-select-selection-placeholder {
        color: ${(props) => props.theme.black} !important;
    }
  }

  .export-product-list-wrapper,
  .clear-filters-button-wrapper {
    margin-top: 16px;

    .ant-btn {
      width: 100%;
      height: 30px;
      background-color: transparent;
      border: 1px solid ${({ theme }) => theme.brand02};
      border-radius: 30px;
      font-size: 13px;
      font-weight: 400;
      color: ${({ theme }) => theme.colorText};
    }
  }

  .clear-filters-button-wrapper {
    .ant-btn {
      &:hover {
        border-color: ${({ theme }) => theme.brand02};
        color: ${({ theme }) => theme.brand02};
      }
    }
  }

  .products-navigate-list {
    display: flex;
    flex-direction: column;
    padding-bottom: 15px;

    a {
      display: block;
      padding: 15px 0;
      border-bottom: 1px solid ${(props) => props.theme.lightGrayBorder};
      font-size: 14px;
      line-height: 28px;
      font-weight: 500;
      color: ${(props) => props.theme.colorText};
    }
  }

  .ant-select {
    max-width: 100% !important;
    min-height: 54px !important;
  }

  .qmark {
    display: grid !important;
    grid-template-columns: 1fr 1fr;
    gap: 10px;

    .ant-checkbox-wrapper-in-form-item {
      display: flex;
      align-items: center;
    }

    .ant-form-item {
      margin: 0;
      min-width: 100%;
    }

    @media only screen and (max-width: 786px) {
      grid-template-columns: 1fr;
    }
  }

  .qmark-filter-title {
    font-size: 14px;
    font-weight: 500;
    line-height: 28px;
    color: ${(props) => props.theme.colorText};
  }

  .ant-checkbox-wrapper-in-form-item span {
    font-size: 14px;
    font-weight: 400;
    color: ${(props) => props.theme.colorText};
    line-height: 16px;
  }

  :where(.ant-checkbox-checked).ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${(props) =>
    props.theme.activeCheckboxBackground} !important;
    border-color: ${(props) => props.theme.activeCheckboxBorder} !important;
  }

  .distance-radius-input {
    .ant-input-number,
    .ant-input-number-group-wrapper .ant-input-number {
      background-color: ${(props) => props.theme.lightGrey} !important;
      border: 1px solid ${(props) => props.theme.borderBottom} !important;
      min-height: 54px;

      &:focus-within {
        background-color: ${(props) => props.theme.softShadowGray} !important;
        border-color: ${(props) => props.theme.softSlateBlue} !important;
      }
    }

    .ant-input-number-group-wrapper {
      min-height: 54px;
      border: none;
      background-color: transparent;

      .ant-input-number-group-addon {
        background-color: ${(props) => props.theme.lightGrey};
        border-color: ${(props) => props.theme.borderBottom};
      }

      &:focus-within .ant-input-number-group-addon {
        background-color: ${(props) => props.theme.softShadowGray};
        border-color: ${(props) => props.theme.softSlateBlue};
      }
    }
  }
`;
